/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Legaroo_Landing_TitleInputs */

const en_service_legaroo_landing_title = /** @type {(inputs: Service_Legaroo_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legal Support On Your Journey`)
};

const fr_service_legaroo_landing_title = /** @type {(inputs: Service_Legaroo_Landing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Soutien juridique pour votre voyage`)
};

/**
* | output |
* | --- |
* | "Legal Support On Your Journey" |
*
* @param {Service_Legaroo_Landing_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_legaroo_landing_title = /** @type {((inputs?: Service_Legaroo_Landing_TitleInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Legaroo_Landing_TitleInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_legaroo_landing_title(inputs)
	return fr_service_legaroo_landing_title(inputs)
});